import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
	padding: 16px 0;
`;

const Inner = styled.ul`
	display: flex;
`;
const List = styled.li<{ active: boolean }>`
	width: 12px;
	height: 12px;
	background-color: ${(props) => props.theme.color.white};
	border-radius: 100%;
	opacity: ${(props) => (props.active ? 1 : 0.5)};
	margin: 0 4px;
	cursor: pointer;
`;
const Indecator: React.FC<{ count: number; nowCount: number; onClick: (type: number) => void; className?: string }> = ({ count, nowCount, onClick, className }) => {
	const renderer = Array(count).fill(null);

	return (
		<Wrapper className={className}>
			<Inner>
				{renderer.map((el, index) => {
					return <List active={index === nowCount ? true : false} key={index} onClick={() => onClick(index)} />;
				})}
			</Inner>
		</Wrapper>
	);
};

export default Indecator;
